module.exports = __webpack_public_path__ + "img/brunei.889dfca.webp";